(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["header-l1"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-mobile-theme-search]');
    if (!input) return;
    const group = input.closest('[data-mobile-theme-group]');
    if (!group) return;
    const query = input.value.trim().toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const directory = group.querySelector('[data-mobile-theme-directory]');
    const directoryLabel = directory.querySelector('summary');
    if (!directoryLabel.dataset.allLabel) directoryLabel.dataset.allLabel = directoryLabel.textContent;
    const popular = group.querySelector('[data-mobile-theme-popular]');
    const empty = group.querySelector('[data-mobile-theme-empty]');
    let matches = 0;
    group.querySelectorAll('[data-mobile-theme-item]').forEach((item) => {
      const name = item.dataset.themeName.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const visible = !query || name.includes(query);
      item.hidden = !visible;
      if (visible) matches += 1;
    });
    popular.hidden = Boolean(query);
    directoryLabel.textContent = query ? `${directoryLabel.dataset.searchLabel} (${matches})` : directoryLabel.dataset.allLabel;
    directoryLabel.setAttribute('aria-label', directoryLabel.textContent);
    directory.open = Boolean(query);
    empty.hidden = !query || matches > 0;
    directory.parentElement.hidden = Boolean(query) && matches === 0;
  });
  } catch(e) { console.error(e); }
})();

})();
